export const PRODUCT_DATA = "PRODUCT_DATA";
export const PRODUCT_ERROR_DATA = "PRODUCT_ERROR_DATA";
export const PRODUCT_HIDE_ERROR_DATA = "PRODUCT_HIDE_ERROR_DATA";
export const PRODUCT_START_LOADER = "PRODUCT_START_LOADER";
export const PRODUCT_STOP_LOADER = "PRODUCT_STOP_LOADER";
